import { render, staticRenderFns } from "./DTCreate.vue?vue&type=template&id=282d8c40&"
import script from "./DTCreate.vue?vue&type=script&lang=js&"
export * from "./DTCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports